
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(204|48|567|696)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
